import { Cameras, ItemManager, Scene, Camera, CanvasInfo, ThreeViewBase, defines } from "./index";
import * as THREE from "three";

/* Renderer
 * レンダラクラス.
 */
export class Renderer {

    _instance: THREE.WebGLRenderer;
    public get me(): THREE.WebGLRenderer { return <THREE.WebGLRenderer>(this._instance); }
    public set me(i: THREE.WebGLRenderer) { this._instance = i; }

    private _cameras: Cameras;
    public get cameras(): Cameras { return this._cameras; }
    public set_cameras(cams: Cameras) { this._cameras = cams; }

    private _items: ItemManager;
    public get items(): ItemManager { return this._items; }
    public set_items(items: ItemManager) { this._items = items; }

    protected _rendering_scene: Scene;
    protected _rendering_camera: Camera;

    private _posteffect: boolean;
    public get posteffect(): boolean { return this._posteffect && this.postEffectEnabled(); }
    protected postEffectEnabled(): boolean { return false; }
    public set posteffect(enabled: boolean) {
        this._posteffect = enabled;
        if (this._posteffect) this.initPostEffect();
    }

    constructor(container: HTMLElement, params: {}) {
        this.me = new THREE.WebGLRenderer(params);
        this.me.outputEncoding = THREE.sRGBEncoding;

        this.canvasSizeChanged();

        document.body.appendChild(this.me.domElement);
        container.appendChild(this.me.domElement);
    }

    public preprocess(timeStamp: number): void {
        if (this.cameras != undefined) {
            this.cameras.update(this.items, timeStamp);
        }
        if (this.items != undefined)
            this.items.update(this.cameras, timeStamp);
        if (this._rendering_scene != undefined)
            this._rendering_scene.update(this.items, this.cameras, timeStamp);
    }

    public posprocess(timeStamp: number) {
    }

    protected initPostEffect(): boolean {
        if ((this._rendering_scene == undefined) || (this._rendering_camera == undefined))
            return false;
        return true;
    }

    public _render(): void {
        this.me.render(this._rendering_scene.me, this._rendering_camera.me);
    }

    public render(scene: Scene, camera: Camera): void {
        this._rendering_scene = scene;
        this._rendering_camera = camera;
        this._render();
    }

    public animation(scene: Scene, camera: Camera): void {
        let anim_callback = (timeStamp?: number) => {
            const renderer = ThreeViewBase.get().renderer;
            if ((renderer._rendering_scene != undefined) && (renderer._rendering_camera != undefined)) {
                renderer.preprocess(timeStamp);

                window.requestAnimationFrame(anim_callback);
                if (ThreeViewBase.get().visible) this._render();
                renderer.posprocess(timeStamp);
            }
        }
        this._rendering_scene = scene;
        this._rendering_camera = camera;
        anim_callback();
    }

    public canvasSizeChanged(): void {
        const size = CanvasInfo.get().size;
        this.me.setSize(size.x, size.y);
    }

    public reset(options: defines.Options): void {
        if (options.is(defines.ResetOptions.resetRenderer, true)) {
            this._rendering_scene = undefined;
            this._rendering_camera = undefined;
        }
    }
}
